document.addEventListener('DOMContentLoaded', function () {
  var splide = new Splide('.nothing--pdp--right--cols', {
    type: 'slide',
    perPage: 1,
    drag: 'free',
    snap: true,
    perMove: 1,
    flickPower: 150,
    flickMaxPages: 1,
    easing: 'ease-in-out',
    arrows: false,
    pagination: true,
    gap: '0rem',
  }).mount();

  function equalizeComparisonHeights() {
    const allCols = [
      ...document.querySelectorAll('.nothing--pdp--chat--table--left--col'),
      ...document.querySelectorAll('.splide__slide')
    ];
    if (!allCols.length) return;

    const numRows = allCols[0].querySelectorAll('.pdp--chart--cell').length;
    const isMobile = window.innerWidth < 767;

    for (let i = 0; i < numRows; i++) {
      let defaultHeight = isMobile
        ? (i === 0 ? 125 : 68)
        : (i === 0 ? 196 : 80);
      let maxHeight = defaultHeight;

      // Reset heights before recalculating
      allCols.forEach(col => {
        const cell = col.querySelectorAll('.pdp--chart--cell')[i];
        if (cell) cell.style.minHeight = 'auto';
      });

      // Find tallest cell in this row
      allCols.forEach(col => {
        const cell = col.querySelectorAll('.pdp--chart--cell')[i];
        if (cell) maxHeight = Math.max(maxHeight, cell.scrollHeight);
      });

      // Set same height across all columns
      allCols.forEach(col => {
        const cell = col.querySelectorAll('.pdp--chart--cell')[i];
        if (cell) cell.style.minHeight = maxHeight + 'px';
      });
    }
  }

  window.addEventListener('load', equalizeComparisonHeights);
  window.addEventListener('resize', () => {
    clearTimeout(window.eqTimer);
    window.eqTimer = setTimeout(equalizeComparisonHeights, 150);
  });

  document.addEventListener('splide:mounted', equalizeComparisonHeights);
  document.addEventListener('splide:updated', equalizeComparisonHeights);

  document.querySelectorAll('img').forEach(img => {
    img.addEventListener('load', equalizeComparisonHeights, { once: true });
  });

  const fullSection = document.querySelector('.nothing--pdp--chat--table--info');
  if (fullSection) {
    let startX = 0;
    fullSection.addEventListener('touchstart', e => (startX = e.touches[0].clientX));
    fullSection.addEventListener('touchend', e => {
      const diff = startX - e.changedTouches[0].clientX;
      if (Math.abs(diff) > 50) splide.go(diff > 0 ? '>' : '<');
    });
  }
});
